module.exports = __webpack_public_path__ + "static/media/plusIcon.e797218a.svg";